import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6727cc6c")

_pushScopeId("data-v-6727cc6c")
const _hoisted_1 = { class: "updateltlinvoice" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "updateltlinvoice__message" }, " Редактировать данные груза можно только до обработки склада SPARK ", -1)
const _hoisted_4 = {
  key: 0,
  class: "updateltlinvoice__state"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "state__text" }, "Загрузка данных накладной...", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "state__text failed" }, " Произошла ошибка при загрузке данных накладной, попробуйте ещё раз ", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Перезагрузить")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_loader = _resolveComponent("s-loader")!
  const _component_s_button = _resolveComponent("s-button")!
  const _component_receiver_create = _resolveComponent("receiver-create")!
  const _component_s_modal = _resolveComponent("s-modal")!
  const _component_ltl_receiver = _resolveComponent("ltl-receiver")!
  const _component_ltl_cargo_payment = _resolveComponent("ltl-cargo-payment")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h2", _hoisted_2, _toDisplayString(_ctx.pageTitle), 1),
    _hoisted_3,
    (!_ctx.state.is_loaded)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _hoisted_5,
                _createVNode(_component_s_loader)
              ], 64))
            : (_ctx.state.is_failed)
              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_6,
                  _createVNode(_component_s_button, {
                    class: "primary",
                    onClick: _ctx.loadInvoice
                  }, {
                    default: _withId(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.is_loaded)
      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          (_ctx.isReceiverActionsOpened)
            ? (_openBlock(), _createBlock(_component_s_modal, {
                key: 0,
                onClose: _ctx.closeReceiverActions
              }, {
                body: _withId(() => [
                  _createVNode(_component_receiver_create, {
                    isLTL: true,
                    isFTL: false,
                    "sender-city-id": _ctx.senderCityId,
                    status: _ctx.state.invoice.status.code,
                    onUpdate: _ctx.updateReceiverHandler,
                    onClose: _ctx.closeReceiverActions
                  }, null, 8, ["sender-city-id", "status", "onUpdate", "onClose"])
                ]),
                _: 1
              }, 8, ["onClose"]))
            : _createCommentVNode("", true),
          (Boolean(_ctx.receivers_state.receiver))
            ? (_openBlock(), _createBlock(_component_ltl_receiver, {
                key: 1,
                blocked: _ctx.state.is_submiting || !_ctx.isCanUpdateReceiver,
                receiver: _ctx.receivers_state.receiver,
                onReset: _ctx.startUpdateReceiver
              }, null, 8, ["blocked", "receiver", "onReset"]))
            : _createCommentVNode("", true),
          (_ctx.isCanUpdateCargo)
            ? (_openBlock(), _createBlock(_component_ltl_cargo_payment, {
                key: 2,
                opened: true,
                "sender-title": _ctx.state.invoice.company_name,
                "company-id": _ctx.state.invoice.company_id,
                "is-only-auto": _ctx.isOnlyAuto,
                "is-pvz": _ctx.isPvz,
                "is-update": true,
                "updating-invoice": _ctx.state.updating_invoice,
                loading: _ctx.state.is_submiting,
                "receiver-city-type": _ctx.receivers_state.receiver ? _ctx.receivers_state.receiver.city_type : null,
                onUpdateInvoice: _ctx.submitInvoice
              }, null, 8, ["sender-title", "company-id", "is-only-auto", "is-pvz", "updating-invoice", "loading", "receiver-city-type", "onUpdateInvoice"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
})